import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import Select, { components } from "react-select";

const customStyles = {
  // change the height of the select box to 100px
  control: (provided, state) => ({
    ...provided,
    boxShadow: state.isFocused ? 0 : 0,
    borderColor: state.isFocused ? "transparent" : "transparent",
    "&:hover": {
      borderColor: state.isFocused ? "transparent" : "transparent",
    },
    padding: 0, // remove padding
    backgroundColor: "transparent",
    height: "24px",
  }),
  container: (provided) => ({
    ...provided,
    zIndex: "10",
  }),

  valueContainer: (base) => ({
    ...base,
    padding: "0px", // remove padding
    // width: "185px",
  }),

  // style the label color
  singleValue: (provided, state) => {
    return {
      ...provided,
      color: "#0000FF",
    };
  },
  menu: (provided) => ({
    ...provided,
    borderRadius: "var(--border-radius-md)",
    overflow: "hidden",
    marginTop: "-2px",
    width: "185px",
  }),
  menuList: (base) => ({
    ...base,
    paddingTop: 0, // remove top padding
    paddingBottom: 0, // remove bottom padding
    overflow: "hidden",
  }),
};

const Option = (props) => {
  const { innerProps, children, state } = props;

  const optionStyle = {
    backgroundColor: state.isFocused ? "#f1f0ff" : null,
    curser: "pointer !important",
  };

  return (
    // reuseing th class name used in the location search, because in listing loacation search component also used
    <div {...innerProps} className="location-search-item" style={optionStyle}>
      {children}
    </div>
  );
};

const CustomSingleValue = ({ children, ...props }) => {
  const { menuIsOpen, isFocused } = props.selectProps;

  // get the focus state of the select

  return (
    <components.SingleValue {...props}>
      {/* You can add any custom components or styles here */}
      <div
        style={{
          cursor: "pointer",
          width: "fit-content",
          display: "flex",
          alignItems: "center",
          gap: "3px",
        }}
      >
        {children}
        <div
          style={{
            position: "relative",
            bottom: ".5px",
            fill: menuIsOpen ? "#7a7a7a" : "var(--border-clr-dark)",
            transition: "all .1s ease-in-out",
          }}
        >
          <DropDownArrow />
        </div>
      </div>
    </components.SingleValue>
  );
};

const customComponents = {
  IndicatorSeparator: () => null,
  DropdownIndicator: () => null,
  Option: (props) => (
    <Option
      {...props}
      state={props} // Pass the state prop to the custom Option component
    />
  ),

  SingleValue: CustomSingleValue,
};

const SelectSuggestionType = ({ goToPropertyListingPage }) => {
  const [selectedSuggestionType, setSelectedSuggestionType] = React.useState({
    value: "suggestion",
    label: "any room count",
  });
  const [searchParams] = useSearchParams();

  const room_count = searchParams.get("rooms");
  const suggestion_type = searchParams.get("rcst");

  const options = [];

  setOptionsByOrder(options, suggestion_type, room_count);

  useEffect(() => {
    if (room_count) {
      if (suggestion_type === "eq") {
        setSelectedSuggestionType(options[1]);
      } else if (suggestion_type === "gte") {
        setSelectedSuggestionType(options[2]);
      } else if (suggestion_type === "lte") {
        setSelectedSuggestionType(options[3]);
      } else {
        setSelectedSuggestionType(options[0]);
      }
    }
  }, []);

  return (
    <Select
      className="listing-suggestion-type"
      value={selectedSuggestionType}
      defaultValue={options[0]}
      onChange={(e) => {
        goToPropertyListingPage(null, null, e.value);
        setSelectedSuggestionType(e);
      }}
      name="suggestion type"
      options={options}
      styles={customStyles}
      components={customComponents}
      isSearchable={false}
    />
  );
};

export default SelectSuggestionType;

function setOptionsByOrder(options, suggestion_type, room_count) {
  const room_wording = room_count === "1" ? "room" : "rooms";

  if (suggestion_type === "suggestion") {
    options.unshift({ value: "suggestion", label: "any room count" });
  } else {
    options.push({ value: "suggestion", label: "any room count" });
  }

  if (suggestion_type === "eq") {
    options.unshift({
      value: "eq",
      label: `${room_count} ${room_wording} only`,
    });
  } else {
    options.push({
      value: "eq",
      label: `${room_count} ${room_wording} only`,
    });
  }

  if (room_count < 30) {
    if (suggestion_type === "gte") {
      options.unshift({
        value: "gte",
        label: `${room_count} ${room_wording} or more`,
      });
    } else {
      options.push({
        value: "gte",
        label: `${room_count} ${room_wording} or more`,
      });
    }
  }

  if (room_count > 1) {
    if (suggestion_type === "lte") {
      options.unshift({
        value: "lte",
        label: `${room_count} ${room_wording} or less`,
      });
    } else {
      options.push({
        value: "lte",
        label: `${room_count} ${room_wording} or less`,
      });
    }
  }
}

function DropDownArrow() {
  return (
    <svg
      height="20"
      width="20"
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
    </svg>
  );
}
